import { jsxs, jsx } from "react/jsx-runtime";
import { FieldContainer } from "@contember/ui";
import { deprecate, isDefined, fallback } from "@contember/utilities";
import { memo } from "react";
import { AccessorErrors } from "../../errors/AccessorErrors.js";
import { CreateNewEntityButton } from "../helpers/CreateNewEntityButton.js";
import { EmptyMessage } from "../helpers/EmptyMessage.js";
const RepeaterFieldContainer = memo(
  ({
    accessor,
    addButtonText,
    boxLabel,
    children,
    createNewEntity,
    addButtonComponent: AddButton = CreateNewEntityButton,
    addButtonComponentExtraProps,
    addButtonProps,
    emptyMessage,
    emptyMessageComponent,
    enableAddingNew = true,
    formatMessage,
    isEmpty,
    label,
    ...rest
  }) => {
    deprecate("1.3.0", isDefined(boxLabel), "`boxLabel` prop", "`label` prop");
    label = fallback(label, isDefined(boxLabel), boxLabel);
    return /* @__PURE__ */ jsxs(
      FieldContainer,
      {
        label,
        ...rest,
        useLabelElement: false,
        footer: enableAddingNew && /* @__PURE__ */ jsx(
          AddButton,
          {
            ...addButtonComponentExtraProps,
            ...addButtonProps,
            createNewEntity,
            children: addButtonText ?? label ?? formatMessage("repeater.addButton.text")
          }
        ),
        children: [
          /* @__PURE__ */ jsx(AccessorErrors, { accessor }),
          isEmpty && /* @__PURE__ */ jsx(EmptyMessage, { component: emptyMessageComponent, children: formatMessage(emptyMessage, "repeater.emptyMessage.text") }),
          isEmpty || children
        ]
      }
    );
  }
);
RepeaterFieldContainer.displayName = "RepeaterFieldContainer";
export {
  RepeaterFieldContainer
};
//# sourceMappingURL=RepeaterFieldContainer.js.map
